import React from "react";
import { Grid, Box, Typography, Avatar } from "@mui/material";
import "./TransferReceiveARModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";

import CompDirection from "../../../themes/CompDirection";
import { themes } from "../../../themes/themes";
import TakeActionSplitBtn from "../../../components/TakeActionSplitBtn/TakeActionSplitBtn";
import HorizontalStepperForActionRequired from "../../../components/HorizontalStepperForActionRequired/HorizontalStepperForActionRequired";
import PromotionRecentlyPromotedTile from "../../../components/PromotionRecentlyPromotedTile/PromotionRecentlyPromotedTile";
import RecentlyTransferredARTile from "../../../components/RecentlyTransferredARTile/RecentlyTransferredARTile";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allClaimTypes: any;
  callBackGetData: (data: any) => void;
  trans?: any;
}

const TransferReceiveARModalPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allClaimTypes,
  trans,
}: ModalProps) => {
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="35vw">
      <ModalHeader
        modal={{ modal_title: trans("Transfer Receive Action Required") }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "5px",
          }}
        >
          <Grid item xs={6}>
            <Box className="bg_border_ar_promotion">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Avatar />
                <Box style={{ paddingLeft: "10px" }}>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      color: themes.darkBlue,
                      fontSize: "1em",
                      fontWeight: "bold",
                    }}
                  >
                    Amellia Russel
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      color: themes.grey_colorDesignationAR,
                      fontSize: "0.825em",
                    }}
                  >
                    Development / UX Designer
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    Transfer Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    30 May, 2022
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    Transfer From
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: themes.primaryMain,
                      backgroundColor: "#F2E6F0",
                      padding: "5px",
                      borderRadius: "4px",
                    }}
                  >
                    Google
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    Transfer To
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "#21D8A5",
                      backgroundColor: "#E8FBF6",
                      padding: "5px",
                      borderRadius: "4px",
                    }}
                  >
                    Alphabet HQ
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    Attachment
                  </Typography>
                  <Box>
                    <i className="las la-eye" color={themes.primary} />
                  </Box>
                </Box>
              </Box>
              {/* <Box
                style={{
                  display: "flex",
                  marginTop: "0.5em",
                  width: "auto",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: themes.defaultScondary_blue,
                  }}
                >
                  Remarks
                </Typography>
                <Typography
                  style={{
                    fontFamily: "Lato",
                    fontSize: "12px",
                    color: themes.greyModalTitle,
                  }}
                >
                  Last 4 days I am not good
                </Typography>
              </Box> */}
              <Box style={{ marginTop: "1.5em" }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: "1.5em", zIndex: "999", width: "100%" }}>
                <TakeActionSplitBtn
                  onSelect={() => alert(1)}
                  menu={[{ id: 1, label: "a" }]}
                  title={"Take Action"}
                />
              </Box>
            </Box>
          </Grid>
          {/* {Second Column} */}

          <Grid item xs={6}>
            <Box className="bg_border_ar_promotion">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    color: themes.primaryMain,
                    fontSize: "0.875em",
                    fontWeight: "bold",
                  }}
                >
                  Recently Transferred
                </Typography>
              </Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    color: themes.greySubtitle,
                    fontSize: "0.875em",
                    fontWeight: "bold",
                  }}
                >
                  Department:{" "}
                  <span style={{ color: themes.defaultScondary_blue }}>
                    All
                  </span>
                </Typography>
                <Box
                  style={{
                    border: "1px solid #979797",
                    borderRadius: "4px",
                    alignSelf: "center",
                    padding: "8px",
                    cursor: "pointer",
                  }}
                >
                  <i className="las la-filter" color="#464545" />
                </Box>
              </Box>
              <RecentlyTransferredARTile
                designation="Development / UX Designation"
                name="Amelia Khan"
                transferTo="Alphabet HQ"
              />
            </Box>
          </Grid>

          {/* {Horizontals Steps Label} */}
          <Grid item xs={12}>
            <Box
              style={{
                border: "1px solid #0000001f",
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <HorizontalStepperForActionRequired direction="horizontal" />
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default TransferReceiveARModalPresenter;
